import * as React from 'react';

import {CalendarPenIcon} from 'shells/icon/svg/calendar-pen-icon';
import {CalendarXIcon} from 'shells/icon/svg/calendar-x-icon';
import {ConnectionInfoDescription} from 'shells/status-button/connection-info-description';

export function ConnectedCalendarInfoDescription() {
    const descriptionItems = [
        {
            icon: <CalendarPenIcon size={15} alignCenter={true} />,
            text: 'New event bookings will be added here.',
        },
        {
            icon: <CalendarXIcon size={16} alignCenter={true} />,
            text: 'We check here for conflicts when displaying available time slots for invitees to book.',
        },
    ];

    return <ConnectionInfoDescription items={descriptionItems} />;
}
